export enum NameType {
  Smittamne = 'SMITTAMNE',
  Antibiotika = 'ANTIBIOTIKUM',
  Analys = 'ANALYS',
  Provmaterial = 'PROVMATERIAL',
  BeskrivandeFynd = 'BESKRIVANDE',
  NegativtFynd = 'NEGATIVT',
}

export enum NameStatus {
  Oforandrat = 'OFÖRÄNDRAT',
  Andrat = 'ÄNDRAT',
  Ej_Tolkningsbart = 'EJ_TOLKNINGSBART',
}

export interface Link {
  url: string;
  text: string;
}

export interface LarmKriteriumDTO {
  period: number;
  num: number;
  id?: string;
  type: string;
  name: string;
  species: string;
  status: string;
  analysis: any[];
  labs: any[];
  sampleMaterials: any[];
  antibiotics: AntibiotikaList;
}

export interface AntibiotikaList {
   [key: number]: AntibiotikaDTO;
}

export interface AntibiotikaDTO {
  name: string;
  sir?: string;
  zon?: number;
  tolk?: string;
  mic?: any;
  selectedAntibiotika?: { standardNamn: string };
  sortOrder?: number;
}

export interface WarningDTO {
  criteria?: string;
  provId?: string;
  lab?: string;
  newWarning?: boolean;
  recurringWarning?: boolean;
}

export interface WarningListDTO {
  warnings?: WarningDTO[];
  newWarnings?: number;
}
export interface WarningsCriteriaDTO {
  values?: {
    [key: string]: WarningListDTO;
  };

  newWarnings?: number;
}
export interface WarningsDTO {
  values?: {
    [key: string]: WarningsCriteriaDTO;
  };
}
